import { render, staticRenderFns } from "./CustomMetricsSoonBanner.vue?vue&type=template&id=30be38b5&scoped=true"
import script from "./CustomMetricsSoonBanner.vue?vue&type=script&lang=js"
export * from "./CustomMetricsSoonBanner.vue?vue&type=script&lang=js"
import style0 from "./CustomMetricsSoonBanner.vue?vue&type=style&index=0&id=30be38b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30be38b5",
  null
  
)

export default component.exports